class DefaultActivationValidator {
  validate(items) {
    const report = {
      valid: [],
      invalid: [],
      error: []
    };
    items.forEach((thing, index) => {
      if (thing.version === 2) {
        report.valid.push(thing);
      } else {
        console.warn(`Activation ${index} is invalid for the following reasons:`, `unknown version "${thing.version}"`, thing);
      }
    });
    console.debug("Validation report:", report);
    return items;
  }
}
export {
  DefaultActivationValidator
};
